import { render, staticRenderFns } from "./MultipleChoiceOneOrManyAnswers.vue?vue&type=template&id=3680e110&scoped=true&"
import script from "./MultipleChoiceOneOrManyAnswers.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceOneOrManyAnswers.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceOneOrManyAnswers.vue?vue&type=style&index=0&id=3680e110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3680e110",
  null
  
)

export default component.exports